import { render, staticRenderFns } from "./PricingRebateFees.vue?vue&type=template&id=02aa1a4e&scoped=true"
import script from "./PricingRebateFees.vue?vue&type=script&lang=ts"
export * from "./PricingRebateFees.vue?vue&type=script&lang=ts"
import style0 from "./PricingRebateFees.vue?vue&type=style&index=0&id=02aa1a4e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02aa1a4e",
  null
  
)

export default component.exports